<template>
  <div id="Cupones" class="p-5 d-flex justify-content-center">
    <div class="text-white" style="max-width: 760px; width: 100%;">
      <h1 class="text-center">Generación de cupones</h1>

      <div class="form-group mt-4">
        <label class="font-weight-bold">Código del cupón</label>
        <input
          v-model="form.code"
          type="text"
          class="form-control"
          placeholder="Ej: MAMA2026, AMOR50"
          maxlength="20"
          @input="form.code = form.code.toUpperCase().replace(/[^A-Z0-9]/g, '')"
        />
        <small class="text-light">Solo letras y números, sin espacios. Mayúsculas.</small>
      </div>

      <div class="form-group">
        <label class="font-weight-bold">Tipo de descuento</label>
        <div class="d-flex">
          <div class="form-check mr-4">
            <input
              type="radio"
              id="tipo-porcentual"
              class="form-check-input"
              value="porcentual"
              v-model="form.tipo_Descuento"
            />
            <label class="form-check-label" for="tipo-porcentual">Porcentual (%)</label>
          </div>
          <div class="form-check">
            <input
              type="radio"
              id="tipo-pesos"
              class="form-check-input"
              value="pesos"
              v-model="form.tipo_Descuento"
            />
            <label class="form-check-label" for="tipo-pesos">Cantidad de pesos</label>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="font-weight-bold">
          {{ form.tipo_Descuento === 'porcentual' ? 'Porcentaje (%)' : 'Cantidad ($)' }}
        </label>
        <input
          v-model="form.cant"
          type="number"
          class="form-control"
          :max="form.tipo_Descuento === 'porcentual' ? 100 : null"
          min="1"
        />
      </div>

      <hr style="border-color: rgba(255,255,255,0.3);" />
      <h5>Limitaciones</h5>

      <div class="form-group">
        <label class="font-weight-bold">Vence el</label>
        <input
          v-model="form.expiresAt"
          type="date"
          class="form-control"
          :min="todayISO"
        />
      </div>

      <div class="form-group">
        <label class="font-weight-bold">Máximo total de canjes</label>
        <input
          v-model.number="form.maxRedemptions"
          type="number"
          class="form-control"
          min="1"
          placeholder="Ej: 50"
        />
        <small class="text-light">Dejar vacío para sin límite (no recomendado).</small>
      </div>

      <div class="form-check mt-2">
        <input
          type="checkbox"
          id="one-per-email"
          class="form-check-input"
          v-model="form.oneUsePerEmail"
        />
        <label class="form-check-label" for="one-per-email">
          Un canje por correo electrónico
        </label>
      </div>

      <div class="form-group mt-3">
        <label class="font-weight-bold">Aplicable a</label>
        <div class="form-check">
          <input
            type="radio"
            id="scope-all"
            class="form-check-input"
            value="all"
            v-model="form.scope"
          />
          <label class="form-check-label" for="scope-all">Todas las experiencias</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="scope-specific"
            class="form-check-input"
            value="specific"
            v-model="form.scope"
          />
          <label class="form-check-label" for="scope-specific">Una experiencia específica</label>
        </div>
        <input
          v-if="form.scope === 'specific'"
          v-model="form.experienceId"
          type="text"
          class="form-control mt-2"
          placeholder="ID de la experiencia"
        />
      </div>

      <button
        class="btn btn-warning btn-block mt-3"
        :disabled="!formValido"
        @click="generarCupon"
      >
        Generar cupón
      </button>

      <div v-if="resp" class="resp py-3 text-center">
        <span class="text-warning">{{ resp }}</span>
      </div>

      <hr style="border-color: rgba(255,255,255,0.3);" />
      <h5 class="text-center">Cupones disponibles</h5>

      <table class="table table-borderless text-white mt-3">
        <thead>
          <tr>
            <th>Código</th>
            <th>Desc.</th>
            <th>Vence</th>
            <th>Canjes</th>
            <th>Estado</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="c in cuponesOrdenados" :key="c.cupon">
            <td><strong>{{ c.cupon }}</strong></td>
            <td>{{ formatoDescuento(c) }}</td>
            <td>{{ formatoFecha(c.expiresAt) }}</td>
            <td>{{ (c.redemptionCount || 0) }}/{{ c.maxRedemptions || '—' }}</td>
            <td>
              <span :class="estadoClase(c)">{{ estadoTexto(c) }}</span>
            </td>
            <td>
              <button
                class="btn btn-danger btn-sm"
                @click="eliminar(c.cupon)"
              >
                Eliminar
              </button>
            </td>
          </tr>
          <tr v-if="cupones.length === 0">
            <td colspan="6" class="text-center text-light">
              No hay cupones creados todavía.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "Cupones",
  metaInfo: {
    title: "Generador de cupones",
  },
  data() {
    return {
      form: {
        code: "",
        tipo_Descuento: "porcentual",
        cant: "",
        expiresAt: "",
        maxRedemptions: null,
        oneUsePerEmail: true,
        scope: "all",
        experienceId: "",
      },
      resp: "",
      cupones: [],
    };
  },
  computed: {
    todayISO() {
      const d = new Date();
      return d.toISOString().slice(0, 10);
    },
    formValido() {
      const f = this.form;
      if (!f.code || f.code.length < 4) return false;
      if (!f.tipo_Descuento) return false;
      if (!f.cant || Number(f.cant) <= 0) return false;
      if (f.tipo_Descuento === "porcentual" && Number(f.cant) > 100) return false;
      if (!f.expiresAt) return false;
      if (f.scope === "specific" && !f.experienceId) return false;
      return true;
    },
    cuponesOrdenados() {
      return [...this.cupones].sort((a, b) => {
        const eA = (a.expiresAt && a.expiresAt.seconds) || 0;
        const eB = (b.expiresAt && b.expiresAt.seconds) || 0;
        return eB - eA;
      });
    },
  },
  methods: {
    generarCupon() {
      const f = this.form;
      const code = f.code.trim().toUpperCase();
      if (this.cupones.some((c) => c.cupon === code)) {
        this.resp = `Ya existe un cupón con el código ${code}`;
        return;
      }
      const expiresAt = firebase.firestore.Timestamp.fromDate(
        new Date(f.expiresAt + "T23:59:59")
      );
      const data = {
        cupon: code,
        tipo_Descuento: f.tipo_Descuento,
        cant: String(f.cant),
        usado: false,
        expiresAt,
        maxRedemptions: f.maxRedemptions ? Number(f.maxRedemptions) : null,
        redemptionCount: 0,
        oneUsePerEmail: !!f.oneUsePerEmail,
        redeemedEmails: [],
        appliesTo: {
          scope: f.scope,
          experienceId: f.scope === "specific" ? f.experienceId.trim() : null,
        },
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      };
      firebase
        .firestore()
        .collection("cupones")
        .doc(code)
        .set(data)
        .then(() => {
          this.resp = `Cupón ${code} creado con éxito`;
          this.form.code = "";
          this.form.cant = "";
          this.form.expiresAt = "";
          this.form.maxRedemptions = null;
          this.form.experienceId = "";
        })
        .catch((err) => {
          this.resp = `Error: ${err.message}`;
        });
    },
    eliminar(c) {
      if (!confirm(`¿Eliminar el cupón ${c}? Esta acción no se puede deshacer.`)) return;
      firebase.firestore().collection("cupones").doc(c).delete();
    },
    formatoDescuento(c) {
      if (c.tipo_Descuento === "porcentual") return `${c.cant}%`;
      const n = Number(c.cant);
      return `$${n.toLocaleString("es-CL")}`;
    },
    formatoFecha(ts) {
      if (!ts || !ts.toDate) return "—";
      const d = ts.toDate();
      return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
    },
    estadoActual(c) {
      const ahora = new Date();
      if (c.expiresAt && c.expiresAt.toDate && c.expiresAt.toDate() < ahora) return "vencido";
      if (c.maxRedemptions != null && (c.redemptionCount || 0) >= c.maxRedemptions) return "agotado";
      return "activo";
    },
    estadoTexto(c) {
      const e = this.estadoActual(c);
      return { activo: "● Activo", vencido: "● Vencido", agotado: "● Agotado" }[e];
    },
    estadoClase(c) {
      const e = this.estadoActual(c);
      return {
        "text-success": e === "activo",
        "text-warning": e === "vencido",
        "text-danger": e === "agotado",
      };
    },
  },
  mounted() {
    firebase
      .firestore()
      .collection("cupones")
      .onSnapshot(
        (querySnapshot) => {
          let cupones = [];
          querySnapshot.forEach((c) => {
            cupones.push(c.data());
          });
          this.cupones = cupones;
        },
        (err) => {
          console.log(`Encountered error: ${err}`);
        }
      );
  },
};
</script>
